interface ScoreBarProps {
  score?: string;
  rangeColor?: string;
}

export const ScoreBar = ({ score, rangeColor }: ScoreBarProps) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "end",
      }}
    >
      <p style={{ fontWeight: "bold", fontSize: "1rem" }}>Entenda a distribuição da faixa de risco</p>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "20px",
          borderRadius: '25px',
          background: "linear-gradient(90deg,#DE1616,#FFCA39,#0DAB01)",
          alignItems: "center",
          justifyContent: "center",
        }}
      >

      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <ScoreInfo title="Muito Alto" score="300 a 500" />
        <ScoreInfo title="Alto" score="500 a 600" />
        <ScoreInfo title="Médio" score="600 a 700" />
        <ScoreInfo title="Baixo" score="700 a 900" />
        <ScoreInfo title="Muito Baixo" score="900 a 1000" />
      </div>
    </div>
  );
};

interface ScoreInfoProps {
  title: string;
  score: string;
}

const ScoreInfo = ({ title, score }: ScoreInfoProps) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", fontSize: "1.25rem" }}>{title}</p>
      <p style={{ fontWeight: "500" }}>{score}</p>
    </div>
  );
};